<div class="dialog-content-wrapper order-remark" style="margin: -24px;">
	<mat-toolbar matDialogTitle class="mat-indigo-800-bg m-0 customBlue">
		<mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
			<span class="title dialog-title"> {{ translations.lblDialogTitle + " " + (data != undefined && data.RemarkBy
				== 'distributor' ? translations.lblRemarkByDistributor : translations.lblRemarkByShipper ) }} :: {{
				data.InvoiceNo.toString().toUpperCase() + ' >> ' + data.C_Name }} </span>
			<button mat-button class="mat-icon-button" (click)="dialogRef.close()" aria-label="Close dialog">
				<mat-icon>close</mat-icon>
			</button>
		</mat-toolbar-row>
	</mat-toolbar>
	<div mat-dialog-content class="p-24 m-0" fusePerfectScrollbar
		style="height: 50vh;width:calc(100vh - 100px);padding: 10px 30px !important">

		<div class="remark-container remark-by-distibutor" *ngIf="data != undefined && data.RemarkBy == 'distributor'">
			<mat-form-field>
				<textarea rows="4" [disabled]="orderRemark.R_ID == CONSTANTS.SHIPPER" matInput maxlength="500"
					placeholder="{{ translations.lblOrderRemark }}" [(ngModel)]="orderRemark.D_Remark"
					#distributorRemark></textarea>
			</mat-form-field>
		</div>
		<div class="remark-container remark-by-shipper" *ngIf="data != undefined && data.RemarkBy == 'shipper'">
			<mat-form-field>
				<textarea rows="4" [disabled]="orderRemark.R_ID == CONSTANTS.DISTRIBUTER" matInput maxlength="500"
					placeholder="{{ translations.lblOrderRemark }}" [(ngModel)]="orderRemark.S_Remark"
					#shipperRemark></textarea>
			</mat-form-field>
		</div>
		<h4>{{ translations.lblRemarkHistory }}</h4>
		<div *ngIf="data != undefined && data.RemarkBy == 'distributor'">
			<div class="remark-container remark-by-distibutor" fxLayout="row" fxLayoutAlign="start start">
				<mat-form-field fxFlex="50">
					<input matInput disabled placeholder="{{ translations.lblCreatedDate }}"
						[(ngModel)]="orderRemark.D_CreatedDate" readonly>
				</mat-form-field>

				<mat-form-field fxFlex="50">
					<input matInput disabled placeholder="{{ translations.lblModifiedDate }}"
						[(ngModel)]="orderRemark.D_ModifiedDate" readonly>
				</mat-form-field>
			</div>
			<div class="remark-container remark-by-distibutor" fxLayout="row" fxLayoutAlign="start start">
				<mat-form-field fxFlex="50">
					<input matInput disabled placeholder="{{ translations.lblCreatedBy }}"
						[(ngModel)]="orderRemark.D_CreatedBy" readonly>
				</mat-form-field>

				<mat-form-field fxFlex="50">
					<input matInput disabled placeholder="{{ translations.lblModifiedBy }}"
						[(ngModel)]="orderRemark.D_ModifiedBy" readonly>
				</mat-form-field>
			</div>
		</div>


		<div *ngIf="data != undefined && data.RemarkBy == 'shipper'">
			<div class="remark-container remark-by-distibutor" fxLayout="row" fxLayoutAlign="start start">
				<mat-form-field fxFlex="50">
					<input matInput disabled placeholder="{{ translations.lblCreatedDate }}"
						[(ngModel)]="orderRemark.S_CreatedDate" readonly>
				</mat-form-field>

				<mat-form-field fxFlex="50">
					<input matInput disabled placeholder="{{ translations.lblModifiedDate }}"
						[(ngModel)]="orderRemark.S_ModifiedDate" readonly>
				</mat-form-field>
			</div>
			<div class="remark-container remark-by-distibutor" fxLayout="row" fxLayoutAlign="start start">
				<mat-form-field fxFlex="50">
					<input matInput disabled placeholder="{{ translations.lblCreatedBy }}"
						[(ngModel)]="orderRemark.S_CreatedBy" readonly>
				</mat-form-field>

				<mat-form-field fxFlex="50">
					<input matInput disabled placeholder="{{ translations.lblModifiedBy }}"
						[(ngModel)]="orderRemark.S_ModifiedBy" readonly>
				</mat-form-field>
			</div>
		</div>
		<h4>{{ translations.lblRemarkRead }}</h4>
		<div class="remark-container remark-by-distibutor" *ngIf="data != undefined && data.RemarkBy == 'distributor'">

			<mat-form-field>
				<input matInput disabled placeholder="{{ translations.lblRemarkDate }}"
					[(ngModel)]="orderRemark.D_ReadDate">
				<!-- <mat-datepicker-toggle matSuffix [for]="s_readDatePicker"></mat-datepicker-toggle>
			  <mat-datepicker #s_readDatePicker></mat-datepicker> -->
			</mat-form-field>

			<mat-form-field>
				<input matInput disabled placeholder="{{ translations.lblRemarkReadBy }}"
					[(ngModel)]="orderRemark.D_Name">
			</mat-form-field>

			<br />

			<mat-slide-toggle style="float:right !important;margin-top:8px;"
				[disabled]="orderRemark.R_ID == CONSTANTS.DISTRIBUTER" (change)="distributorMarkedAsReadChanged($event)"
				[checked]="orderRemark.S_IsRead == 2">
				{{ translations.lblMarkAsRead }}
			</mat-slide-toggle>
		</div>
		<div class="remark-container remark-by-shipper" *ngIf="data != undefined && data.RemarkBy == 'shipper'">

			<mat-form-field>
				<input matInput disabled placeholder="{{ translations.lblRemarkDate }}"
					[(ngModel)]="orderRemark.S_ReadDate">
				<!--  <mat-datepicker-toggle disabled matSuffix [for]="d_readDatePicker"></mat-datepicker-toggle>
			  <mat-datepicker #d_readDatePicker></mat-datepicker> -->
			</mat-form-field>

			<mat-form-field>
				<input matInput disabled placeholder="{{ translations.lblRemarkReadBy }}"
					[(ngModel)]="orderRemark.S_Name">
			</mat-form-field>

			<br />

			<mat-slide-toggle style="float:right !important;margin-top:8px;"
				[disabled]="orderRemark.R_ID == CONSTANTS.SHIPPER" (change)="shipperMarkedAsReadChanged($event)"
				[checked]="orderRemark.D_IsRead == 2">
				{{ translations.lblMarkAsRead }}
			</mat-slide-toggle>
		</div>
	</div>
	<div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="right">
		<button mat-raised-button color="accent" (click)="saveRemark()" aria-label="SAVE" fxFlex="47">
			{{ translations.btnRemarkSave }}
		</button>
		<button mat-raised-button color="warn" aria-label="CLOSE" mat-dialog-close fxFlex="47">
			{{ translations.btnRemarkCancel }}
		</button>
	</div>
</div>


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/order-remark/order-remark.component.html